import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDBox, FDTitleText } from '@facet-wealth/design';
import SimplePicker from 'Helpers/SimplePicker';

export default function WhatIfScenarioAssumptionsClientDisclaimer({
  resource,
}) {
  return (
    <SimplePicker
      resource={resource}
      relationship={fr.relationships.clientScenarioDisclaimer.name}
      hasRelationship={() => (
        <FDBox paddingY={3}>
          <FDTitleText size={'sm'} value={'These scenarios are illustrative and based on several assumptions, and are also based on the information you’ve shared with your planner. If anything noteworthy has changed in your life that would affect the information you’ve shared, or if you have any questions about how these scenarios are built, please message your planner.'} />
        </FDBox>
      )}
    />
  );
}

WhatIfScenarioAssumptionsClientDisclaimer.propTypes = {
  resource: PropTypes.object.isRequired,
};
